<div [formGroup]="form" class="form-item-card card border border-success mb-1 shadow-sm form-modal rounded-3 position-relative">
  <div class="card-body p-3">
    <div class="form-check form-switch d-flex align-items-center gap-2">
      <input class="form-check-input focus-ring focus-ring-success" formControlName="intermediaryEnabled" id="insuranceItemIntermediary"
        role="switch" sharedFormInput type="checkbox">
      <label class="form-check-label fw-bold" for="insuranceItemIntermediary">Selecciona tu intermediario</label>
    </div>
    @if (form.get('intermediaryEnabled')?.value) {
    <div class="itemIntermediarySelect border-top pt-3 mt-3">
      <label class="form-label small fw-semibold text-muted text-uppercase uppercase d-block mb-2"
        for="insuranceItemIntermediarySelect">
        Intermediario preferido
      </label>
      <ng-select [dropdownPosition]="'top'" [items]="producers" bindLabel="producerName"
        bindValue="producerCode" class="fw-bold" formControlName="intermediary" id="insuranceItemIntermediarySelect"
        placeholder="Selecciona un intermediario" sharedFormInput>
        <ng-template let-items="items" let-markedItem="markedItem" ng-dropdown-panel>
          <div class="ng-dropdown-panel custom-intermediary-panel shadow-sm">
            <div class="ng-dropdown-panel-items py-1">
              @if (!items.length) {
              <div class="ng-option text-muted small px-3 py-2">
                No hay intermediarios disponibles
              </div>
              }
              @for (option of items; track option) {
              <ng-option [class.ng-option-marked]="option === markedItem" [value]="option.value">
                <div class="d-flex flex-column">
                  <span class="fw-semibold">{{ option.value.producerName }}</span>
                  <small class="text-muted">Código {{ option.value.producerCode }}</small>
                </div>
              </ng-option>
              }
            </div>
          </div>
        </ng-template>
      </ng-select>
    </div>
    }
  </div>
</div>
